<template>
  <footer class="ui--footer">
    <div class="container-footer">
      <div class="box-footer">
        <div class="box-nav">
          <div class="box-contactus">
            <div class="item-logo">
              <a href="/"><img src="/static/svg/logo.svg" alt="LOGO" /></a>
              <p style="margin-bottom: 10px; display: none">CONTACT US</p>
            </div>
            <div class="item-link" style="margin-top: 25px">
              <img
                style="width: 60%; max-width: 215px"
                src="/static/images/home/240726/icon-list.png"
              />
            </div>
            <div class="item-link" style="display: none">
              <p><span style="color: #16adfd">Phone:</span> 217-903-5860</p>
              <p>
                <span style="color: #16adfd">Media:</span>
                media@smartz.cloud
              </p>
              <p>
                <span style="color: #16adfd">Business:</span>
                partner@smartz.cloud
              </p>
            </div>
          </div>
          <div class="list-link">
            <div class="link-item">
              <p class="link-title">Support</p>
              <ul class="linklist">
                <li><a href="/faq">FAQ</a></li>
<!--                 <li><a href="/deal">Deal</a></li>-->
                <li><a href="/my-order">Order Track</a></li>
                <!-- <li><a>Refund</a></li> -->
              </ul>
            </div>
            <div class="link-item">
              <p class="link-title">Get Involved</p>
              <ul class="linklist">
                <li><a href="/new-marketplace">Join the Community</a></li>
                <li><a href="/new-marketplace">Partnership Program</a></li>
                <li><a href="/terms-of-services">Terms of Services</a></li>
                <li><a href="/privacy-policy">Privacy Policy</a></li>
              </ul>
            </div>
            <div class="link-item">
              <p class="link-title">Company</p>
              <ul class="linklist">
                <li><a href="/why-smartz">About</a></li>
                <li><a href="/contact-us">Contact</a></li>
                <li><a href="/careers">Careers</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="box-copyright">
          <p>Copyright © {{year}} Smartz. All rights reserved</p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
// import jQuery from "jquery";
export default {
  name: "test",
  data() {
    return {
      year: '2025',
    };
  },
  methods: {

  },
  mounted() {
    // jQuery(function() {
    //   jQuery('#getHelp').click(function() {
    //       jQuery('#w-livechat').trigger('click');
    //   })
    // })

    let dt = new Date();
    this.year = dt.getFullYear();
  },
};
</script>
<style lang="scss" scope>
@import "@/assets/css/common.scss";
.ui--footer {
   .container-footer {
    background: #ffffff;
    // margin-top: 80px;
    // background-color: #f9fafe;
    .box-footer {
      width: 80%;
      max-width: 1340px;
      margin: 0 auto;
      padding: 60px 0;
      @media screen and (max-width: 800px) {
        padding: 30px 0 0;
        width: 85%;
      }
      .box-nav {
        display: -webkit-flex;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 800px) {
          flex-direction: column;
        }
        .box-contactus {
          width: 270px;
          display: -webkit-flex;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          @media screen and (max-width: 800px) {
            width: 100%;
            margin-bottom: 10px;
          }
          .item-logo {
            img {
              width: 115px;
              margin-bottom: 20px;
            }
            p {
              color: $mainColor;
              font-size: 18px;
              font-family: $mainFontFamily;
              letter-spacing: 1px;
            }
          }
          .item-link {
            display: -webkit-flex;
            display: flex;
            flex-direction: column;
            @media screen and (max-width: 800px) {
              padding-bottom: 10px;
              border-bottom: 1px solid #e0e0e0;
            }
            p {
              font-size: 16px;
              // font-family: 'Roboto Regular';
              color: #000000;
              margin: 4px 0;
            }
          }
        }
        .list-link {
          position: relative;
          width: calc(100% - 530px);
          display: -webkit-flex;
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          // @media screen and (max-width: 1400px) {
          //     width: calc(100% - 360px);
          // }
          // @media screen and (max-width: 1024px) {
          //     width: calc(100% - 330px);
          // }
          @media screen and (max-width: 800px) {
            flex-direction: column;
            width: 100%;
            right: unset;
          }
        }
      }
      .box-copyright {
        padding: 30px 0 20px;
        text-align: center;
        @media screen and (max-width: 800px) {
          padding: 10px 0 10px;
        }
        p {
          font-size: 16px;
          font-family: $mainFontFamily;
          color: #9094a6;
        }
      }
    }
    .link-item {
      .sw-pc {
        display: inherit;
        // @media screen and (max-width: $media-max-width) {
        //     display: none;
        // }
      }
      .sw-sm {
        display: none;
        // @media screen and (max-width: $media-max-width) {
        //     display: inherit;
        // }
      }
      .link-title {
        color: $mainColor;
        font-size: 18px;
        // font-family: 'Roboto Medium';
        margin-bottom: 25px;
        @media screen and (max-width: 800px) {
          margin-bottom: 10px;
        }
      }
      .linklist {
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        // width: 290px;
        @media screen and (max-width: 800px) {
          margin-bottom: 10px;
          max-width: unset;
          padding-bottom: 10px;
          border-bottom: 1px solid #e0e0e0;
        }
        li {
          font-size: 16px;
          color: #000000;
          // font-family: 'Roboto Regular';
          margin: 7px 0;
          @media screen and (max-width: 800px) {
            margin: 8px 0px;
          }
          a {
            color: #000000;
            text-decoration: none;
          }
          &:hover {
            // @media screen and (min-width: $media-max-width) {
            //     a{
            //     color: $mainColor;
            //     }
            // }
          }
        }
      }
    }
    .social-list {
      display: -webkit-flex;
      display: flex;
      flex-direction: row;
      max-width: 220px;
      margin-left: 0px;
      margin-top: 60px;
      // @media screen and (max-width: $media-max-width) {
      //     max-width: unset;
      //     margin-top: 30px;
      // }
      li {
        font-size: 14px;
        color: #000000;
        // font-family: 'GothamLight';
        margin: 0px 10px 0 0;
        // @media screen and (max-width: $media-max-width) {
        //     margin: 0px 8px;
        // }
        a {
          color: #000000;
          text-decoration: none;
        }
        &:hover {
          // @media screen and (min-width: $media-max-width) {
          //     a{
          //         color: $mainColor;
          //     }
          // }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue